import { Dispatch, SetStateAction } from "react"
import { phone as phoneCheck } from "phone"
import { ValidEmailRegex } from "../constants"
import { CountryData } from "react-phone-input-2"

export const validatePhoneNumber = (phone: string, setInvalid: Dispatch<SetStateAction<string>>) => {
  if (!phoneCheck(`+${phone}`, { validateMobilePrefix: false, strictDetection: false }).isValid) {
    setInvalid("Invalid phone number") // can't use i18n and hook because it is not a component
  } else {
    setInvalid("")
  }
}
interface ValidatePhoneNumberAvailabilityProps {
  setValid: Dispatch<SetStateAction<boolean>>
  setErrorMessage: Dispatch<SetStateAction<string>>
  checkPhoneNumberAvailable: (variables: Record<string, unknown>) => Record<string, any>
  phone: string
  country: unknown | CountryData
}
export const validatePhoneNumberAvailability = async (props: ValidatePhoneNumberAvailabilityProps) => {
  const { setValid, setErrorMessage, checkPhoneNumberAvailable, phone, country } = props
  const countryCode = (country as CountryData).dialCode
  const phoneCountryCode = Number(countryCode)
  const phoneNumber = phone.substring(countryCode.length)
  const phoneCountryIso2Code = (country as CountryData).countryCode
  if (
    !phoneCheck(`+${phoneCountryCode}${phoneNumber}`, {
      strictDetection: false,
      validateMobilePrefix: false,
      country: phoneCountryIso2Code,
    }).isValid
  ) {
    setErrorMessage("Invalid phone number")
  } else {
    const response = await checkPhoneNumberAvailable({
      variables: { phoneCountryCode, phoneNumber },
    })
    if (!response.data?.PhoneNumberAvailable) {
      setErrorMessage("This phone number already exists.")
    } else {
      setErrorMessage("")
      setValid(true)
    }
  }
}

export const validateEmail = (email: string, setInvalid: Dispatch<SetStateAction<string>>) => {
  if (!ValidEmailRegex.test(email)) {
    setInvalid("Invalid email")
  } else {
    setInvalid("")
  }
}

interface ValidateEmailAvailabilityProps {
  setValid: Dispatch<SetStateAction<boolean>>
  email: string
  setErrorMessage: Dispatch<SetStateAction<string>>
  checkEmailAvailable: (variables: Record<string, unknown>) => Record<string, any>
}
export const validateEmailAvailability = async (props: ValidateEmailAvailabilityProps) => {
  const { setValid, email, setErrorMessage, checkEmailAvailable } = props
  if (!ValidEmailRegex.test(email)) {
    setErrorMessage("Invalid email")
  } else {
    const response = await checkEmailAvailable({ variables: { email } })
    if (!response.data?.EmailAvailable) {
      setErrorMessage("This email already exists. Choose a different email.")
    } else {
      setErrorMessage("")
      setValid(true)
    }
  }
}
